<div class="screen">
  <div class="screen-inner">
    @if (broadcast) {
      <header class="topbar">
        <span></span>
        <h1 class="topbar-title">{{ headline() }}</h1>
        <span></span>
      </header>
    } @else {
      <app-shell nav="back" action="menu" [title]="headline()" [backTo]="backTo()"></app-shell>
    }

    @if (board) {
      <div class="format-line">
        <span></span>
        <p class="section-label">{{ board.formatLabel }}</p>
        <span class="format-side">
          @if (eventOrganizer) {
            <a class="format-admin" [href]="adminHref" target="_blank" rel="noopener">Admin</a>
          }
        </span>
      </div>
      <p class="section-label">{{ subtitle() }}</p>

      @if (placesDecided) {
        <nav class="tabs">
          <button type="button" class="tab" [class.tab-active]="tab === 'results'" (click)="tab = 'results'">Results</button>
          <button type="button" class="tab" [class.tab-active]="tab === 'leaderboard'" (click)="tab = 'leaderboard'">Leaderboard</button>
        </nav>
      }

      @if (showResults) {
        <div class="card">
          @for (winner of winners; track $index) {
            <div class="row row-static">
              <span class="medal" [class.medal-gold]="winner.place === 1" [class.medal-silver]="winner.place === 2" [class.medal-bronze]="winner.place === 3" [attr.aria-label]="placeLabel(winner.place)">
                <svg viewBox="0 0 32 32" aria-hidden="true">
                  <path fill="currentColor" d="M11 3h10v3.4c0 2.7-1.8 5-4.2 5.6L17.1 15h2.4v2.2h-7V15h2.4l.3-3C12.8 11.4 11 9.1 11 6.4V3z"/>
                  <path fill="currentColor" d="M11 5.4H8c.4 2.2 1.7 3.6 3.5 4v-1.8c-.9-.3-1.5-1.1-1.6-2.2H11zm10 0h3c-.4 2.2-1.7 3.6-3.5 4V7.6c.9-.3 1.5-1.1 1.6-2.2H21z"/>
                  <path fill="currentColor" d="M12.6 18.6h6.8v2h-6.8zm-1.6 2.8h10v2.2h-10z"/>
                </svg>
              </span>
              @if (showWinnerFaces) {
                <span class="face-slot">
                  <app-face [urls]="winner.photos"></app-face>
                </span>
              }
              <span class="row-body">
                <span class="row-title">{{ winner.name }}</span>
              </span>
            </div>
          }
          @if (pinWinner) {
            <div class="row row-static">
              <span class="medal medal-pin" aria-label="Closest to the pin">
                <svg viewBox="0 0 32 32" aria-hidden="true">
                  <path fill="#f5c518" d="M15.2 4.6 26.4 9.6 15.2 14.6z"/>
                  <path fill="currentColor" d="M13.6 4h2.2v19.2h-2.2z"/>
                  <path fill="currentColor" d="M8 25.4c1.3-1.7 3.8-2.8 6.7-2.8s5.4 1.1 6.7 2.8c-1.3 1.7-3.8 2.8-6.7 2.8s-5.4-1.1-6.7-2.8z"/>
                </svg>
              </span>
              @if (showWinnerFaces) {
                <span class="face-slot">
                  <app-face [urls]="pinWinner.photos"></app-face>
                </span>
              }
              <span class="row-body">
                <span class="row-title">{{ pinWinner.name }}</span>
                <span class="row-meta">Closest to the pin</span>
              </span>
            </div>
          }
        </div>
      }

      @if (showLeaderboard) {
      @if (board.rows.length === 0) {
        <p class="page-note">No scores yet.</p>
      } @else {
        <div class="card">
          @for (row of board.rows; track row.competitorId) {
            <div class="lb-item">
              <button type="button" class="lb-row lb-expandable" [class.row-highlight]="isMe(row)" [attr.aria-expanded]="isOpen(row)" (click)="toggle(row)">
                <span class="lb-rank">{{ row.rank }}</span>
                <span class="lb-name">
                  @if (hasFaces) {
                    <span class="face-slot">
                      <app-face [urls]="row.photos"></app-face>
                    </span>
                  }
                  <span class="lb-name-text">
                    {{ row.name }}
                    @if (board.usesRunningTee && row.currentTeeName) {
                      <span class="lb-tee">{{ row.currentTeeName }}</span>
                    }
                  </span>
                </span>
                <span class="lb-topar" [class.lb-ns]="noScore(row)">{{ scoreLabel(row) }}</span>
                <span class="lb-hole" [class.lb-time]="row.lastHole == null && !!row.teeTime" [class.lb-warn]="missingTeeTime(row)">{{ holeLabel(row) }}</span>
              </button>
              @if (isOpen(row)) {
                <div class="lb-detail">
                  <p class="lb-detail-name">{{ row.detailName || row.name }}</p>
                  @if (row.tiebreaker) {
                    <button type="button" class="lb-tie-link" (click)="showTiebreaker(row)">Show Tiebreaker</button>
                  }
                  @if (row.keeps) {
                    <div class="lb-keeps">
                      @for (item of row.keeps; track item.par) {
                        <div class="keep-stat" [class.keep-done]="item.kept >= item.need">
                          <span class="keep-par">Par {{ item.par }}</span>
                          <span class="keep-count">{{ item.kept }} of {{ item.need }} kept</span>
                          <span class="keep-discard">{{ item.discarded }} discarded</span>
                        </div>
                      }
                    </div>
                  }
                  @if (playedHoles(row).length === 0) {
                    <p class="lb-card-empty">No holes yet.</p>
                  } @else {
                    <div class="lb-card">
                      @if (teamCard(row)) {
                        <div class="lb-card-row lb-card-team lb-card-head" [ngClass]="playerCountClass(row)">
                          <span></span>
                          <span></span>
                          @for (player of cardPlayers(row); track player.name) {
                            <span class="lb-player-cell">
                              <span></span>
                              <span class="lb-card-player">{{ player.name }}</span>
                              <span></span>
                            </span>
                          }
                          <span class="lb-card-player lb-team-label">Team</span>
                        </div>
                      }
                      @for (hole of playedHoles(row); track hole.sequence) {
                        @if (teamCard(row)) {
                          <div class="lb-card-row lb-card-team" [ngClass]="playerCountClass(row)">
                            <span class="lb-card-hole">{{ hole.hole }}</span>
                            <span class="lb-card-meta">Par {{ hole.par }}</span>
                            @for (player of hole.players ?? []; track player.name) {
                              <span class="lb-player-cell">
                                <span class="lb-card-marks">
                                  @if (player.strokes > 0) {
                                    @for (dot of strokeDots(player.strokes); track dot) {
                                      <span class="sc-dot"></span>
                                    }
                                  }
                                  @if (player.strokes < 0) {
                                    <span class="lb-card-give">{{ givenMarks(player.strokes) }}</span>
                                  }
                                </span>
                                <span class="lb-player-gross">{{ player.gross ?? '–' }}</span>
                                <span class="lb-card-net">{{ player.gross != null && player.net != null && player.net !== player.gross ? player.net : '' }}</span>
                              </span>
                            }
                            <span class="lb-team-score">{{ teamScore(hole) }}</span>
                          </div>
                        } @else {
                          <div class="lb-card-row">
                            <span class="lb-card-hole">
                              <span>{{ hole.hole }}</span>
                              @if (hole.strokes > 0) {
                                <span class="lb-card-marks">
                                  @for (dot of strokeDots(hole.strokes); track dot) {
                                    <span class="sc-dot"></span>
                                  }
                                </span>
                              }
                              @if (hole.strokes < 0) {
                                <span class="lb-card-give">{{ givenMarks(hole.strokes) }}</span>
                              }
                            </span>
                            <span class="lb-card-meta">Par {{ hole.par }}</span>
                            <span class="lb-card-score">
                              {{ hole.kept === false ? 'Out' : hole.gross }}
                              @if (hole.kept !== false && hole.net != null) {
                                <span class="lb-card-net">{{ hole.net }}</span>
                              }
                            </span>
                          </div>
                        }
                      }
                      @if (teamCard(row)) {
                        <div class="lb-card-row lb-card-team lb-card-total" [ngClass]="playerCountClass(row)">
                          <span class="lb-card-hole">Tot</span>
                          <span></span>
                          @for (player of cardPlayers(row); track player.name; let index = $index) {
                            <span class="lb-player-cell">
                              <span></span>
                              <span class="lb-player-gross">{{ playerGrossTotal(row, index) }}</span>
                              <span class="lb-card-net">{{ playerNetTotal(row, index) !== playerGrossTotal(row, index) ? playerNetTotal(row, index) : '' }}</span>
                            </span>
                          }
                          <span class="lb-team-score">{{ teamColumnTotal(row) }}</span>
                        </div>
                      } @else {
                        <div class="lb-card-row lb-card-total">
                          <span class="lb-card-hole">Tot</span>
                          <span></span>
                          <span class="lb-card-score">
                            {{ grossTotal(row) }}
                            <span class="lb-card-net">{{ netTotal(row) }}</span>
                          </span>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }

      @if (sideGames.length > 0) {
        <p class="section-label">Side games</p>
        <div class="card">
          @for (game of sideGames; track game.label) {
            <div class="row row-static">
              <span class="row-body">
                <span class="row-title">{{ game.name }}</span>
                <span class="row-meta">{{ game.label }}</span>
              </span>
            </div>
          }
        </div>
      }

      @if (!broadcast && canScore) {
        <a class="btn-primary" [routerLink]="['/events', eventId, 'score', board.firstRoundId]">Enter my score</a>
        <a class="btn-secondary btn-block" [routerLink]="['/events', eventId, 'score', board.firstRoundId, 'card']">Scorecard</a>
      } @else if (!broadcast && board.inField && !board.scoringEnabled) {
        <p class="page-note">Scoring is closed for this event.</p>
      }
      }
    }

    @if (error) { <p class="error">{{ error }}</p> }
  </div>

  @if (tieRow?.tiebreaker; as tie) {
    <div class="modal-back" (click)="closeTiebreaker()">
      <div class="modal" role="dialog" aria-labelledby="tie-title" (click)="$event.stopPropagation()">
        <h2 id="tie-title">Tiebreaker</h2>
        <p>{{ tieIntro(tieRow!) }}</p>
        @for (step of tie.steps; track $index) {
          <p class="modal-label">{{ step.description }}</p>
          @for (score of step.scores; track score.competitorId) {
            <p class="modal-score">{{ score.name }}: {{ score.score }}</p>
          }
          <p class="modal-summary" [class.modal-winner]="step.result === 'split'">{{ step.summary }}</p>
        }
        <p class="modal-label">Final result</p>
        @for (person of tie.order; track person.competitorId) {
          <p class="modal-score">{{ person.rank }}. {{ person.name }}</p>
        }
        <button class="btn-secondary" type="button" (click)="closeTiebreaker()">Close</button>
      </div>
    </div>
  }
</div>
